<script lang="ts">
  import { createEventDispatcher } from 'svelte';

  export let index: number;
  export let total = 5;
  export let selected: boolean;

  let dispatch = createEventDispatcher();
</script>

<div>
  <button
    on:click={event => dispatch('click', event)}
    on:mouseenter={event => dispatch('hover', event)}
    aria-label="rate {index + 1} out of {total} stars"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill={selected ? 'var(--loop-star)' : 'var(--loop-accent2)'}
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <polygon
        points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"
      />
    </svg>
  </button>
</div>

<style>
  div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    /* height: 100%; */
  }

  button {
    border: none;
    background: none;
    transition: all 0.2s;
  }

  svg {
    height: 30px;
    width: 30px;
    transition: all 0.1s;
  }
</style>
